<template>
    <div>
        <div class="row">
            <div class="column-main-left">
                <div class="content-container">
                    <div class="header">
                        <div class="title">Welcome to UtterAccess</div>
                    </div>
                    <div class="content">
                        <p>Welcome to UtterAccess! UtterAccess is the premier online community for Microsoft Access, Visual Basic, SQL Server, Office and more.</p>
                        <p>UA began in 1997 as AThree.com (Access All Areas), a collection of Access information hosted and maintained by founder Simon Wolf.  Since then, a great many volunteers have put their considerable effort into building and maintaining this amazing community of Access developers, including forum discussion, knowledgebases, articles and an extensive code/database sample library.</p>
                        <p>Registered members have access to all the file attachments that UA is pleased to provide. An added bonus along with many other features such as Access sample databases, professional Access code samples, file uploading, private messaging and forum subscriptions... <em>all this for those who take a moment to sign up...(Your personal information is kept completely confidential and everything is truly free of charge!)</em></p>
                        <p>UA has over 2.5 million posts across 500 thousand topics - proving UtterAccess.com is the only source for help with Microsoft Access...and more!</p>
                    </div>
                </div>
                <PostNewsPreview v-for="topic in newsTopics" :key="topic.topicID" :topic="topic"></PostNewsPreview>
            </div>
            <div class="column-sidebar-right">
                <div class="content-container">
                    <div class="header">
                        <div class="title">UA Important Links</div>
                    </div>
                    <div class="content">                        
                        <p>Please visit our <router-link :to='{ path: "guidelines" }'>Guidelines</router-link> page and <router-link :to='{ path: "boards/22" }'>Q&amp;A, Site Help and Feedback</router-link> board for general site information.  Our <router-link :to='{ path: "topics/2059020?post=last" }'>Release Log</router-link> and topic for <router-link :to='{ path: "topics/2062375?post=last" }'>Feature Requests &amp; Bug Reports</router-link> may also be of interest.</p>
                    </div>
                </div>
                <div class="content-container">
                    <div class="header">
                        <div class="title">Latest Topics</div>
                    </div>
                    <div class="content plain-list">
                        <ul>
                            <li v-for="(topic) in latestTopics" :key="topic.topicID"><router-link :to="{ path: '/topics/' + topic.topicID + '?post=unread' }">{{ topic.title | decodeHtml }}</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PostNewsPreview from '../components/Posts/PostNewsPreview.vue'
    import api from '../api/api';
    import common from '../modules/common';
    export default {
        data() {
            return {
                latestTopics:null,
                newsTopics: null
            }
        },
        components: { 
            PostNewsPreview
        },        
        mounted() {
            var bc = common.breadcrumb.create([
                { url: '/', text: 'UtterAccess' },
                { text: 'Home' }
            ]);
            this.$store.dispatch("breadcrumb", bc);

            api.get('/home').then(response => {
                this.latestTopics = response.data.latestTopics;
                this.newsTopics = response.data.newsTopics;
            });
        }
    }
</script>